import './style.css';


let experiment = null;
let counter = 0;

import('./modules/strandsy.js').then(module => {
  const Strandsy = module.default;
  const canvas = document.getElementById('canvas');
  experiment = new Strandsy(canvas);
  experiment.clear = true;
  // experiment.alphaThreshold = 0.9;
  resize();

  canvas.addEventListener('mousemove', pointerMove, { passive: true });
  canvas.addEventListener('touchmove', pointerMove, { passive: true });
  canvas.addEventListener('mousedown', pointerDown, { passive: true });
  canvas.addEventListener('touchstart', pointerDown, { passive: true });

  window.addEventListener('resize', resize);

  loop();
});

function pointerMove(event) {
  const x = event.clientX || event.clientX === 0 ? event.clientX : event.touches[0].clientX;
  const y = event.clientY || event.clientY === 0 ? event.clientY : event.touches[0].clientY;
  experiment.pointer.x = x * window.devicePixelRatio;
  experiment.pointer.y = y * window.devicePixelRatio;
}

function pointerDown() {
  counter++;

  switch (counter) {
    case 0:
      thiccboi();
      break;
    case 1:
      tubular();
      break;
    case 2:
      wawa();
      break;
    case 3:
      baba();
      break;
    case 4:
      booboo();
      break;
    case 5:
      snoosnoo();
      break;
    case 6:
      snoosnoo2();
      break;
    default:
      random();
  }
}

function resize() {
  experiment.resize(window.innerWidth * window.devicePixelRatio, window.innerHeight * window.devicePixelRatio);
  experiment.canvas.style.width = `${window.innerWidth}px`;
  experiment.canvas.style.height = `${window.innerHeight}px`;
}

function tubular() {
  experiment.clear = false;
  experiment.alphaThreshold = 0;

  experiment.grid.columns = 12;
  experiment.grid.rows = 2;

  experiment.particleConfig.width = 96;
  experiment.particleConfig.height = 96;
  experiment.particleConfig.color = 'blue';
  experiment.pointer.distortionRadius = 20;

  experiment.stroke = true;
  experiment.strokeColor = '#fff';
  experiment.strokeWidth = 4;

  experiment.rebuild();
  experiment.clearCanvas();
}

function thiccboi() {
  experiment.clear = true;
  experiment.alphaThreshold = 0.9;

  experiment.grid.columns = 64;
  experiment.grid.rows = 3;

  experiment.particleConfig.width = 1;
  experiment.particleConfig.height = 1;
  experiment.particleConfig.color = 'black';
  experiment.pointer.distortionRadius = 240;

  experiment.stroke = true;
  experiment.strokeColor = '#f2f3f4';
  experiment.strokeWidth = 100;

  experiment.rebuild();
  experiment.clearCanvas();
}

function wawa() {
  experiment.clear = true;
  experiment.alphaThreshold = 0.9;

  experiment.grid.columns = 64;
  experiment.grid.rows = 64;

  experiment.particleConfig.width = 100;
  experiment.particleConfig.height = 10;
  experiment.particleConfig.color = '#f2f3f4';
  experiment.pointer.distortionRadius = 240;

  experiment.stroke = false;
  experiment.strokeColor = '#000';
  experiment.strokeWidth = 10;

  experiment.rebuild();
  experiment.clearCanvas();
}

function baba() {
  experiment.clear = true;
  experiment.alphaThreshold = 0;

  experiment.grid.columns = 32;
  experiment.grid.rows = 32;

  experiment.particleConfig.width = 4;
  experiment.particleConfig.height = 4;
  experiment.particleConfig.color = '#f2f3f4';
  experiment.pointer.distortionRadius = 640;

  experiment.stroke = true;
  experiment.strokeColor = '#f2f3f4';
  experiment.strokeWidth = 1;

  experiment.rebuild();
  experiment.clearCanvas();
}

function booboo() {
  experiment.clear = false;
  experiment.alphaThreshold = 0;

  experiment.grid.columns = 8;
  experiment.grid.rows = 8;

  experiment.particleConfig.width = 8;
  experiment.particleConfig.height = 8;
  experiment.particleConfig.color = '#f2f3f4';
  experiment.pointer.distortionRadius = 64;

  experiment.stroke = false;
  experiment.strokeColor = '#000';
  experiment.strokeWidth = 10;

  experiment.rebuild();
  experiment.clearCanvas();
}

function snoosnoo() {
  experiment.clear = false;
  experiment.alphaThreshold = 0.5;

  experiment.grid.columns = 8;
  experiment.grid.rows = 8;

  experiment.particleConfig.width = 8;
  experiment.particleConfig.height = 8;
  experiment.particleConfig.color = '#f2f3f4';
  experiment.pointer.distortionRadius = 64;

  experiment.stroke = true;
  experiment.strokeColor = 'rgba(255, 255, 255, 0.1)';
  experiment.strokeWidth = 1;

  experiment.rebuild();
  experiment.clearCanvas();
}

function snoosnoo2() {
  experiment.clear = false;
  experiment.alphaThreshold = 0.2;

  experiment.grid.columns = 6;
  experiment.grid.rows = 6;

  experiment.particleConfig.width = 80;
  experiment.particleConfig.height = 80;
  experiment.particleConfig.color = '#f2f3f4';
  experiment.pointer.distortionRadius = 320;

  experiment.stroke = false;
  experiment.strokeColor = 'rgba(255, 255, 255, 0.1)';
  experiment.strokeWidth = 1;

  experiment.rebuild();
  experiment.clearCanvas();
}

function random() {
  experiment.alphaThreshold = Math.random();

  experiment.grid.columns = Math.floor(Math.random() * 60) + 2;
  experiment.grid.rows = Math.floor(Math.random() * 60) + 2;

  experiment.particleConfig.width = Math.floor(Math.random() * 120);
  experiment.particleConfig.height = Math.floor(Math.random() * 120);
  experiment.particleConfig.color = '#f2f3f4';
  experiment.pointer.distortionRadius = Math.floor(Math.random() * 800);

  experiment.stroke = Math.random() > 0.5;
  experiment.strokeColor = `rgba(255, 255, 255, ${Math.random()}`;
  experiment.strokeWidth = Math.floor(Math.random() * 24);
  experiment.clear = experiment.grid.columns > 30 || experiment.grid.rows > 30;

  experiment.rebuild();
  experiment.clearCanvas();
}

function loop() {
  experiment.update();
  requestAnimationFrame(loop);
}
